<div class="container-fluid p-4">
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-3">
          <a routerLink="/fire-foresight/burn-list" class="btn btn-outline-primary">
            <i class="bi bi-arrow-left"></i> Back
          </a>
          <h3 class="mb-0 h3" *ngIf="selectedRegion">{{ selectedRegion.name }} - Burn Coups</h3>
          <h3 class="mb-0 h3" *ngIf="!selectedRegionId">All Burn Coups</h3>
        </div>
        <div class="d-flex align-items-center gap-3">
          <!-- View Toggle Buttons -->
          <div class="btn-group" role="group">
            <button type="button" 
                    class="btn"
                    [class.btn-primary]="currentView === 'table'"
                    [class.btn-outline-primary]="currentView !== 'table'"
                    (click)="setView('table')"
                    title="Table View">
              <i class="bi bi-table"></i> Table
            </button>
            <button type="button" 
                    class="btn"
                    [class.btn-primary]="currentView === 'map'"
                    [class.btn-outline-primary]="currentView !== 'map'"
                    (click)="setView('map')"
                    title="Map View">
              <i class="bi bi-map"></i> Map
            </button>
          </div>
          <div class="badge bg-info fs-5 px-4 py-2">
            {{ burnCoups.length }} Burn Coup{{ burnCoups.length !== 1 ? 's' : '' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Burn Coups Tables (4 columns for TV) -->
  <div *ngIf="!loading && currentView === 'table'" class="row g-3">
    <div *ngFor="let coupGroup of getCoupGroups(); let columnIndex = index" class="col-3">
      <div class="table-responsive">
        <table class="table table-bordered table-hover mb-0">
          <thead class="table-dark">
            <tr>
              <th style="width: 30%;">Coup</th>
              <th class="text-center" style="width: 20%;">Shade</th>
              <th class="text-center" style="width: 20%;">Open</th>
              <th class="text-center" style="width: 30%;">SDI</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let coup of coupGroup">
              <!-- Coup Name -->
              <td class="align-middle">
                <strong class="d-block">{{ coup.geoAsset?.identifier || 'Coup #' + coup.id | uppercase }}</strong>
                <span *ngIf="coup.disabled" class="badge bg-secondary mt-1">
                  <i class="bi bi-slash-circle"></i> Excluded
                </span>
              </td>
              
              <!-- Shade FM -->
              <td class="p-2 align-middle text-center"
                  [class]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true)"
                  [title]="getFuelMoistureShadedValue(coup.id) !== null ? 'Fuel Moisture (Shade): ' + getFuelMoistureShadedValue(coup.id) + '%' + (isFuelMoistureDataStale(coup.id, true) ? ' (Data older than 6 hours)' : '') : 'No data'">
                <div [class.text-white]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true) !== 'bg-light'"
                     [class.text-dark]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true) === 'bg-light'">
                  <strong *ngIf="getFuelMoistureShadedValue(coup.id) !== null">
                    {{getFuelMoistureShadedValue(coup.id)}}%
                  </strong>
                  <span *ngIf="getFuelMoistureShadedValue(coup.id) === null && !siteTwinsLoading">
                    N/A
                  </span>
                  <span *ngIf="getFuelMoistureShadedValue(coup.id) === null && siteTwinsLoading"
                        class="spinner-border spinner-border-sm"
                        role="status">
                  </span>
                </div>
              </td>
              
              <!-- Open FM -->
              <td class="p-2 align-middle text-center"
                  [class]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false)"
                  [title]="getFuelMoistureUnshadedValue(coup.id) !== null ? 'Fuel Moisture (Open): ' + getFuelMoistureUnshadedValue(coup.id) + '%' + (isFuelMoistureDataStale(coup.id, false) ? ' (Data older than 6 hours)' : '') : 'No data'">
                <div [class.text-white]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false) !== 'bg-light'"
                     [class.text-dark]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false) === 'bg-light'">
                  <strong *ngIf="getFuelMoistureUnshadedValue(coup.id) !== null">
                    {{getFuelMoistureUnshadedValue(coup.id)}}%
                  </strong>
                  <span *ngIf="getFuelMoistureUnshadedValue(coup.id) === null && !siteTwinsLoading">
                    N/A
                  </span>
                  <span *ngIf="getFuelMoistureUnshadedValue(coup.id) === null && siteTwinsLoading"
                        class="spinner-border spinner-border-sm"
                        role="status">
                  </span>
                </div>
              </td>
              
              <!-- SDI -->
              <td class="p-2 align-middle text-center"
                  [class]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id))"
                  [title]="getSDIValue(coup.id) !== null ? 'SDI: ' + getSDIValue(coup.id) + (isSDIDataStale(coup.id) ? ' (Data older than 48 hours)' : '') : 'No data'">
                <div [class.text-white]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id)) !== 'bg-light'"
                     [class.text-dark]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id)) === 'bg-light'">
                  <strong *ngIf="getSDIValue(coup.id) !== null">
                    {{getSDIValue(coup.id)}}
                  </strong>
                  <span *ngIf="getSDIValue(coup.id) === null && !siteTwinsLoading">
                    N/A
                  </span>
                  <span *ngIf="getSDIValue(coup.id) === null && siteTwinsLoading"
                        class="spinner-border spinner-border-sm"
                        role="status">
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Map View -->
  <div *ngIf="!loading && currentView === 'map'" class="row">
    <div class="col-12">
      <!-- Map Component -->
      <div style="height: calc(100vh - 250px); min-height: 600px;">
        <app-map #burnCoupsMap (mapInitComplete)="onMapInitComplete()"></app-map>
      </div>

      <!-- Map Legend -->
      <div class="mt-3">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title mb-3"><i class="bi bi-palette"></i> Legend</h6>
            <div class="row">
              <div class="col-md-3">
                <span class="badge bg-danger me-2">&nbsp;&nbsp;&nbsp;</span>
                <span>Critical (FM < threshold or SDI > 100)</span>
              </div>
              <div class="col-md-3">
                <span class="badge bg-warning me-2">&nbsp;&nbsp;&nbsp;</span>
                <span>Warning (Unshaded FM 14-16%)</span>
              </div>
              <div class="col-md-3">
                <span class="badge bg-success me-2">&nbsp;&nbsp;&nbsp;</span>
                <span>Good (FM & SDI within safe range)</span>
              </div>
              <div class="col-md-3">
                <span class="badge bg-secondary me-2">&nbsp;&nbsp;&nbsp;</span>
                <span>No Data / Stale Data</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No Coups Message -->
  <div *ngIf="!loading && burnCoups.length === 0" class="row">
    <div class="col-12">
      <div class="alert alert-info text-center">
        <i class="bi bi-info-circle me-2"></i>
        No burn coups found{{ selectedRegionId ? ' for this region' : '' }}.
      </div>
    </div>
  </div>
</div>
